import { childTypes } from './enums/childTypes';
import { groupingRelationshipItem } from './models/groupingRelationshipItem';
import { dayOfWeek } from './enums/dayOfWeek';

const helpers = { 
	GetAllNetworkByParentId(parentId: number, relationships: groupingRelationshipItem[]): groupingRelationshipItem[] {
		var self = this;
		var results: groupingRelationshipItem[];
		if (parentId > 0) {
			var network = relationships.filter(item => {
				return item.parentID == parentId;
			});

			results = results.concat(network);

			var childs = network.filter(item => {
				return item.childType == childTypes.Group;
			});

			if (childs.length > 0) {
				childs.forEach(item => {
					results = results.concat(self.GetAllNetworkByParentId(item.childID));
				});
			}
		}

		return results;
	},
	GetDayNameByWeekDay(day: string) {
		switch (day) {
			case dayOfWeek.monday.toString():
				return "Lunedì";
				break;
			case dayOfWeek.tuesday.toString():
				return "Martedì";
				break;
			case dayOfWeek.wednesday.toString():
				return "Mercoledì";
				break;
			case dayOfWeek.thursday.toString():
				return "Giovedì";
				break;
			case dayOfWeek.friday.toString():
				return "Venerdì";
				break;
			case dayOfWeek.saturday.toString():
				return "Sabato";
				break;
			case dayOfWeek.sunday.toString():
				return "Domenica";
				break;

			default:
				break;

				return "";
		}
	}
}

export default helpers;